
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"x1":"50%","y1":"2.231%","x2":"50%","y2":"99.716%","id":"a"}},[_c('stop',{attrs:{"stop-color":"#ECE96B","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#5AB420","offset":"100%"}})])]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"url(#a)","cx":"30","cy":"30","r":"30"}}),_c('path',{attrs:{"d":"M29.832 42.307c-.372 0-.756 0-1.144-.044a16.322 16.322 0 01-8.172-2.917.611.611 0 11.694-1.006 15.122 15.122 0 007.563 2.703c3.456.222 6.886-.73 9.733-2.703a.606.606 0 11.686.994 16.604 16.604 0 01-9.36 2.973zm-8.69-18.397a.606.606 0 00-.606.605v3.636a.606.606 0 101.212 0v-3.636a.606.606 0 00-.606-.606zm20.769 3.118a3.79 3.79 0 00-6.686 0 .606.606 0 101.067.574 2.582 2.582 0 014.553 0 .61.61 0 00.82.246.606.606 0 00.246-.82z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    